// extracted by css-extract-rspack-plugin
export default {"sidebarContainer":"index-module__sidebarContainer__ynQDq"};